import React from 'react';
import GroupBackground from '../../../../Page/Groups/GroupBackground';

class StandardGroupView extends React.Component {
  render() {
    let group = this.props.group;
    return (
      <section
        style={{
          minHeight: group.ls('min_height'),
          paddingTop: group.getPadding()
        }}
      >
        <GroupBackground group={group} />
        <div className="container">
          <div className="row group-section-holder">{this.props.children}</div>
        </div>
      </section>
    );
  }
}

export default StandardGroupView;
